import { Text } from '@wyz/ui';
import clsx from 'clsx';
import * as React from 'react';
type ValueInfoItemProps = {
  title: React.ReactNode;
  id?: string; // for cypress
  width?: string | number;
  align?: 'left' | 'right';
};
const __DEFAULT_ELEMENT__ = 'td';
type ItemOwnProps<E extends React.ElementType = typeof __DEFAULT_ELEMENT__> =
  ValueInfoItemProps & {
    as?: E;
  };

function ValueInfoItem<
  T extends React.ElementType = typeof __DEFAULT_ELEMENT__,
>({
  title,
  align = 'left',
  width,
  children,
  as,
  id,
}: React.PropsWithChildren<ItemOwnProps<T>>) {
  const ComponentToUse = as || __DEFAULT_ELEMENT__;

  return (
    <ComponentToUse
      className='me-2 flex-1'
      style={{
        width: width,
        maxWidth: width,
        minWidth: width,
      }}
    >
      <div
        className={clsx({
          'text-right': align === 'right',
          'text-left': align === 'left',
        })}
      >
        <Text
          heading='xs'
          color='secondary-gray'
          weight='semi-bold'
          className='no-wrap'
        >
          {title}
        </Text>
      </div>
      <div data-cy={id}>{children}</div>
    </ComponentToUse>
  );
}

export default ValueInfoItem;
